"use client";

import { Loader2 } from "lucide-react";
import { useFeedPages } from "./use-feed-pages";

/** The rows of the news feed that load as the reader scrolls, with a small spinner at the end while there are more. */
export function FeedMore({ locale, search, firstPage }: { locale: string; search: Record<string, string>; firstPage: number }) {
  const { batches, done, end } = useFeedPages(locale, search, firstPage);
  return (
    <>
      {batches.map((rows, i) => <div key={i}>{rows}</div>)}
      {!done && <div ref={end} className="flex justify-center py-6"><Loader2 aria-hidden className="size-5 animate-spin text-muted-foreground" /></div>}
    </>
  );
}
